/**
 * Capability drawer link-table sections.
 *
 * ROUND 13 D4. Ten capability dependency edges were committed, three of
 * them forming rings, and no register, drawer, map or scene showed one.
 * The importer's own "See where the 2 edges landed" arrived at a flat
 * capabilities list; `GET`, `POST` and `DELETE` for
 * `/capabilities/{id}/dependencies` had existed since P85.1 and the
 * front end called none of them.
 *
 * An edge has no page of its own, and the place it belongs is the
 * drawer of the entity it hangs off -- which is exactly where the
 * importer's committed-parent route already lands (round 12 A6). This
 * is the section it was landing on and not finding.
 */
import { LinkSection } from "./LinkSection";

export function CapabilityDependencyLinks({ rowId }: { rowId: string }) {
  return (
    <LinkSection
      i18nPrefix="modules.foundation.admin.capabilities.dependencyLinks"
      listEndpoint={`/v1/admin/foundation/capabilities/${rowId}/dependencies`}
      deleteEndpoint={(upstreamId) =>
        `/v1/admin/foundation/capabilities/${rowId}/dependencies/${upstreamId}`
      }
      optionsEndpoint="/v1/admin/foundation/capabilities"
      targetFieldKey="upstream_capability_id"
      queryKey={["foundation-admin", "capabilities", rowId, "dependencies"] as const}
      optionsQueryKey={["foundation-admin", "capabilities", "options"] as const}
    />
  );
}
